"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewAPICommands = exports.AppAPICommands = exports.AnnotationAPICommands = void 0;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const AnnotationAPICommands = exports.AnnotationAPICommands = {
  ADD_ANNOTATIONS: "ADD_ANNOTATIONS",
  ADD_ANNOTATIONS_IN_PDF: "ADD_ANNOTATIONS_IN_PDF",
  REMOVE_ANNOTATIONS_FROM_PDF: "REMOVE_ANNOTATIONS_FROM_PDF",
  GET_ANNOTATIONS: "GET_ANNOTATIONS",
  DELETE_ANNOTATIONS: "DELETE_ANNOTATIONS",
  UPDATE_ANNOTATION: "UPDATE_ANNOTATION",
  SELECT_ANNOTATION: "SELECT_ANNOTATION",
  UNSELECT_ANNOTATION: "UNSELECT_ANNOTATION",
  ANNOTATION_EVENT_LISTENER: "ANNOTATION_EVENT_LISTENER",
  SET_CONFIG: "SET_CONFIG",
  COMMIT_UNSAVED_CHANGES: "COMMIT_UNSAVED_CHANGES",
  START_ANNOTATION_MODE: "START_ANNOTATION_MODE",
  END_ANNOTATION_MODE: "END_ANNOTATION_MODE",
  GET_PDF_BUFFER: "GET_PDF_BUFFER"
};
const AppAPICommands = exports.AppAPICommands = {
  CLOSE_PDF_VIEWER: "CLOSE_PDF_VIEWER",
  ENTER_FULL_SCREEN: "ENTER_FULL_SCREEN",
  EXIT_FULL_SCREEN: "EXIT_FULL_SCREEN",
  SET_HEIGHT_IN_VIEW: "SET_HEIGHT_IN_VIEW",
  TOGGLE_COMMENTING: "TOGGLE_COMMENTING",
  SET_LB_EXIT_PDF_VIEWER_TYPE: "SET_LB_EXIT_PDF_VIEWER_TYPE",
  ENTER_EDIT_MODE: "ENTER_EDIT_MODE",
  UPDATE_EDIT_ENABLED: "UPDATE_EDIT_ENABLED",
  CLOSE_EDIT_MODE: "CLOSE_EDIT_MODE",
  GET_TOOLSBOARD_CONFIG: "GET_TOOLSBOARD_CONFIG",
  START_POLLING: "START_POLLING",
  TOGGLE_SPINNER: "TOGGLE_SPINNER",
  CLEAR_COMMAND_STACK: "CLEAR_COMMAND_STACK",
  ANNOTATION_MODE_END: "ANNOTATION_MODE_END",
  UNDO_LAST_CHANGE: "UNDO_LAST_CHANGE"
};
const PreviewAPICommands = exports.PreviewAPICommands = {
  DISABLE_QUICK_TOOL_VERBS: "DISABLE_QUICK_TOOL_VERBS",
  GET_XMP_METADATA: "GET_XMP_METADATA",
  GET_PDF_METADATA: "GET_PDF_METADATA",
  SET_CURSOR: "SET_CURSOR",
  RESET_CURSOR: "RESET_CURSOR",
  GET_CURRENT_PAGE: "GET_CURRENT_PAGE",
  GET_PAGE_ZOOM_LEVEL: "GET_PAGE_ZOOM_LEVEL",
  GOTO_LOCATION: "GOTO_LOCATION",
  ADD_SPACE_BELOW_DOCUMENT_IN_MOBILE: "ADD_SPACE_BELOW_DOCUMENT_IN_MOBILE",
  CLEAR_PAGE_SELECTION: "CLEAR_PAGE_SELECTION",
  GET_SELECTED_CONTENT: "GET_SELECTED_CONTENT",
  GET_TEXT_FROM_DOC_RECTS: "GET_TEXT_FROM_DOC_RECTS",
  SHOW_HUD: "SHOW_HUD",
  HIDE_HUD: "HIDE_HUD",
  DOWNLOAD_VISIBILITY: "DOWNLOAD_VISIBILITY",
  TOGGLE_TEXT_SELECTION: "TOGGLE_TEXT_SELECTION",
  ENABLE_INTERACTIVE_TOOLTIP: "ENABLE_INTERACTIVE_TOOLTIP",
  PRINT_VISIBILITY: "PRINT_VISIBILITY",
  COMMENTS_PANEL_VISIBILITY: "COMMENTS_PANEL_VISIBILITY",
  FULL_SCREEN_VISIBILITY: "FULL_SCREEN_VISIBILITY",
  PAGE_NAVIGATION_CONTROL_VISIBILITY: "PAGE_NAVIGATION_CONTROL_VISIBILITY",
  PAGE_NUMBER_CONTROL_VISIBILITY: "PAGE_NUMBER_CONTROL_VISIBILITY",
  DOCK_SWITCH_VISIBILITY: "DOCK_SWITCH_VISIBILITY",
  ZOOM_CONTROL_VISIBILITY: "ZOOM_CONTROL_VISIBILITY",
  FIT_PAGE_VISIBILITY: "FIT_PAGE_VISIBILITY",
  FIT_WIDTH_VISIBILITY: "FIT_WIDTH_VISIBILITY",
  TWO_COLUMN_VISIBILITY: "TWO_COLUMN_VISIBILITY",
  FULL_SCREEN_BUTTON_VISIBILITY: "FULL_SCREEN_BUTTON_VISIBILITY",
  HUD_VISIBILITY: "HUD_VISIBILITY",
  LEFT_PANE_VISIBILITY: "LEFT_PANE_VISIBILITY",
  RIGHT_PANE_VISIBILITY: "RIGHT_PANE_VISIBILITY",
  DOCKED_HUD: "DOCKED_HUD",
  SET_SELECTED_ASSET: "SET_SELECTED_ASSET",
  SET_VIEW_MODE: "SET_VIEW_MODE",
  GET_VIEW_MODE: "GET_VIEW_MODE",
  SCRUBBER_VISIBILITY: "SCRUBBER_VISIBILITY",
  FILE_NAME_TOAST_VISIBILITY: "FILE_NAME_TOAST_VISIBILITY",
  SAVE_PDF: "SAVE_PDF",
  APPLY_CNPDF_UPDATES: "APPLY_CNPDF_UPDATES",
  DOWNLOAD_PDF: "DOWNLOAD_PDF",
  CLEAR_FILE_DIRTY_STATUS: "CLEAR_FILE_DIRTY_STATUS",
  GET_PDF_PERMISSIONS: "GET_PDF_PERMISSIONS",
  IS_EDITING_ALLOWED: "IS_EDITING_ALLOWED",
  IS_COMMENTING_ALLOWED: "IS_COMMENTING_ALLOWED",
  SET_FILE_NAME: "SET_FILE_NAME",
  GET_SEARCH_UI: "GET_SEARCH_UI",
  REGISTER_SEARCH_ADDON_PANEL: "REGISTER_SEARCH_ADDON_PANEL",
  REGISTER_STICKY_TOOLS_ADDON_PANEL: "REGISTER_STICKY_TOOLS_ADDON_PANEL",
  SET_LEGAL_DIALOG_OPEN: "SET_LEGAL_DIALOG_OPEN",
  ZOOM_IN: "ZOOM_IN",
  ZOOM_OUT: "ZOOM_OUT",
  SET_ZOOM_LEVEL: "SET_ZOOM_LEVEL",
  GET_ZOOM_LIMIT: "GET_ZOOM_LIMIT",
  START_SEARCH: "START_SEARCH",
  PERFORM_SEARCH: "PERFORM_SEARCH",
  GET_THUMBNAIL: "GET_THUMBNAIL",
  GET_ALL_BOOKMARK: "GET_ALL_BOOKMARK",
  OPEN_BOOKMARK: "OPEN_BOOKMARK",
  GET_ATTACHMENTS: "GET_ATTACHMENTS",
  GET_ATTACHMENT_BUFFER: "GET_ATTACHMENT_BUFFER",
  GET_COMMAND_MANAGER: "GET_COMMAND_MANAGER",
  REGISTER_BEFORE_RHP_OPEN_CALLBACK: "REGISTER_BEFORE_RHP_OPEN_CALLBACK",
  REGISTER_BEFORE_QUICK_TOOL_ACTIVATED_CALLBACK: "REGISTER_BEFORE_QUICK_TOOL_ACTIVATED_CALLBACK",
  REGISTER_BEFORE_STICKY_TOOL_ACTIVATED_CALLBACK: "REGISTER_BEFORE_STICKY_TOOL_ACTIVATED_CALLBACK",
  SHOW_COACH_MARK: "SHOW_COACH_MARK",
  RESET_QUICK_TOOL: "RESET_QUICK_TOOL",
  GET_ACTIVE_QUICK_TOOL: "GET_ACTIVE_QUICK_TOOL",
  SHOW_QUICK_TOOL: "SHOW_QUICK_TOOL",
  SUBSCRIBE_QUICK_TOOL: "SUBSCRIBE_QUICK_TOOL",
  REGISTER_BEFORE_NAVIGATION_BAR_TOOL_ACTIVATED_CALLBACK: "REGISTER_BEFORE_NAVIGATION_BAR_TOOL_ACTIVATED_CALLBACK",
  OPEN_RHP_PANEL: "OPEN_RHP_PANEL",
  CLOSE_RHP_PANEL: "CLOSE_RHP_PANEL",
  SUBSCRIBE_TO_RHP: "SUBSCRIBE_TO_RHP",
  UNSUBSCRIBE_FROM_RHP: "UNSUBSCRIBE_FROM_RHP",
  GET_RHP_CONFIG: "GET_RHP_CONFIG",
  ADD_RHP_UI_CONTROL: "ADD_RHP_UI_CONTROL",
  UPDATE_PREVIEW_APP_CONFIG: "UPDATE_PREVIEW_APP_CONFIG",
  SWITCH_TO_CNPDF: "SWITCH_TO_CNPDF",
  NOTIFY_ASSET_VERSION_UPDATE: "NOTIFY_ASSET_VERSION_UPDATE",
  SHOW_CONFLICTING_FILE_DIALOG: "SHOW_CONFLICTING_FILE_DIALOG",
  FORCE_SHOW_COMMENTING_TOOLS: "FORCE_SHOW_COMMENTING_TOOLS",
  FORCED_SHOW_FULL_WINDOW_MODAL: "FORCED_SHOW_FULL_WINDOW_MODAL",
  START_READ_ALOUD: "START_READ_ALOUD",
  STOP_READ_ALOUD: "STOP_READ_ALOUD",
  IS_READ_ALOUD_PAUSED: "IS_READ_ALOUD_PAUSED",
  PAUSE_READ_ALOUD: "PAUSE_READ_ALOUD",
  PLAY_READ_ALOUD: "PLAY_READ_ALOUD",
  HAS_NEXT_PARAGRAPH: "HAS_NEXT_PARAGRAPH",
  GO_TO_NEXT_PARAGRAPH: "GO_TO_NEXT_PARAGRAPH",
  HAS_PREVIOUS_PARAGRAPH: "HAS_PREVIOUS_PARAGRAPH",
  GO_TO_PREVIOUS_PARAGRAPH: "GO_TO_PREVIOUS_PARAGRAPH",
  SET_VOICE_RATE: "SET_VOICE_RATE",
  GET_VOICE_RATES: "GET_VOICE_RATES",
  GET_SELECTED_VOICE_RATE: "GET_SELECTED_VOICE_RATE",
  SET_VOICE_OPTION: "SET_VOICE_OPTION",
  GET_VOICE_OPTIONS: "GET_VOICE_OPTIONS",
  GET_SELECTED_VOICE_OPTION: "GET_SELECTED_VOICE_OPTION",
  IS_FILE_PROTECTED: "IS_FILE_PROTECTED",
  SHOW_NOTIFICATION: "SHOW_NOTIFICATION",
  CLEAR_ALL_NOTIFICATIONS: "CLEAR_ALL_NOTIFICATIONS",
  CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
  GET_PAGE_THUMBNAIL: "GET_PAGE_THUMBNAIL",
  START_CARET_MODE: "START_CARET_MODE",
  STOP_CARET_MODE: "STOP_CARET_MODE",
  IS_PDF_JAVASCRIPT_ENABLED: "IS_PDF_JAVASCRIPT_ENABLED",
  EXECUTE_DOC_WILL_CLOSE_ACTIONS: "EXECUTE_DOC_WILL_CLOSE_ACTIONS",
  SET_VIEWER_RETARGETED_FILE_INFO: "SET_VIEWER_RETARGETED_FILE_INFO",
  ENABLE_PDF_JAVASCRIPT: "ENABLE_PDF_JAVASCRIPT",
  ENABLE_ACROFORM_VALIDATION_FORMATTING: "ENABLE_ACROFORM_VALIDATION_FORMATTING",
  UPDATE_FILE_META_DATA: "UPDATE_FILE_META_DATA",
  ENABLE_OVERPRINT_SUPPORT: "ENABLE_OVERPRINT_SUPPORT",
  REGISTER_CONTEXT_MENU_HANDLER: "REGISTER_CONTEXT_MENU_HANDLER",
  EXIT_FULL_SCREEN_MODE: "EXIT_FULL_SCREEN_MODE",
  SWITCH_PREVIEW: "SWITCH_PREVIEW",
  SET_DARK_PAGE_THEME_SWITCH_DISABLED: "SET_DARK_PAGE_THEME_SWITCH_DISABLED",
  SET_DOCUMENT_VIEW_THEME_CHANGE: "SET_DOCUMENT_VIEW_THEME_CHANGE",
  SUBSCRIBE_TO_PDF_EDIT_OPERATIONS: "SUBSCRIBE_TO_PDF_EDIT_OPERATIONS",
  GET_UPDATED_PDF_BUFFER: "GET_UPDATED_PDF_BUFFER",
  SET_ASSET_INFO: "SET_ASSET_INFO",
  GET_DOCUMENT_ID: "GET_DOCUMENT_ID",
  INITIAL_PAGE_LOADED: "INITIAL_PAGE_LOADED",
  GET_VISIBLE_PAGE_PDF_RECT: "GET_VISIBLE_PAGE_PDF_RECT",
  REGISTER_OVERLAY: "REGISTER_OVERLAY",
  SHOW_OVERLAY: "SHOW_OVERLAY",
  HIDE_OVERLAY: "HIDE_OVERLAY",
  TRANSFORM_PDF_TO_VIEW: "TRANSFORM_PDF_TO_VIEW",
  TRANSFORM_VIEW_TO_PDF: "TRANSFORM_VIEW_TO_PDF",
  GET_PAGE_ATTRIBUTES: "GET_PAGE_ATTRIBUTES",
  EXTRACT_PAGE_TEXT: "EXTRACT_PAGE_TEXT",
  REGISTER_BEFORE_A11Y_TREE_RENDER_CALLBACK: "REGISTER_BEFORE_A11Y_TREE_RENDER_CALLBACK",
  PRELOAD_EDIT: "PRELOAD_EDIT",
  INSERT_TEXT: "INSERT_TEXT",
  REPLACE_TEXT: "REPLACE_TEXT",
  DELETE_TEXT: "DELETE_TEXT",
  DISCARD_PREVIEW: "DISCARD_PREVIEW",
  SET_BOTTOM_BOARD_PANEL: "SET_BOTTOM_BOARD_PANEL",
  SET_BOTTOM_BOARD_BANNER: "SET_BOTTOM_BOARD_BANNER",
  SHOW_BOTTOM_BOARD_PANEL: "SHOW_BOTTOM_BOARD_PANEL",
  SHOW_BOTTOM_BOARD_BANNER: "SHOW_BOTTOM_BOARD_BANNER",
  SET_BOTTOM_BOARD_CONFIG: "SET_BOTTOM_BOARD_CONFIG",
  SET_FAB_VERB_ID: "SET_FAB_VERB_ID",
  SET_FAB_VISIBILITY: "SET_FAB_VISIBILITY",
  SET_TOP_PANEL_VERB_ID: "SET_TOP_PANEL_VERB_ID",
  SET_TOP_PANEL_VISIBILITY: "SET_TOP_PANEL_VISIBILITY",
  SET_TOP_PANEL_EXPANDED_STATE: "SET_TOP_PANEL_EXPANDED_STATE",
  GET_BBOX_FOR_PAGE: "GET_BBOX_FOR_PAGE",
  GET_BBOX_CONTENT: "GET_BBOX_CONTENT",
  GET_TEXT_BETWEEN_PDF_POINTS: "GET_TEXT_BETWEEN_PDF_POINTS",
  ADD_FLOATING_WINDOW: "ADD_FLOATING_WINDOW",
  UPDATE_DOC_INFO: "UPDATE_DOC_INFO"
};